import clsx from 'clsx'

import { useUtils } from '@pepper/ui'

import {
  BOOK_A_DEMO_URL,
  MARKETPLACE_KNOW_MORE_URL,
} from 'utils/constants/website_urls'

import s from './ContentTypesBanner.module.css'

const CONTENT_TYPES_KEYS = [
  'blog-article',
  'infographics',
  'in-depth-blog',
  'thought-leadership',
  'white-paper',
  'blog-long-form-content',
]

const ContentTypesBanner = () => {
  const { verticals } = useUtils()

  return (
    <div className={s.wrapper}>
      <div className={s.body}>
        <span className={s.sparkle}>&#10024;</span>
        <div className={s.contentBody}>
          <span className={s.title}> ALL CONTENT TYPES</span>
          <span className={s.header}>
            Tailor-made content to achieve your marketing goals
          </span>
          <div className={s.buttonsContainer}>
            <button
              className={clsx(s.button, s.buttonDark)}
              onClick={() => window.open(BOOK_A_DEMO_URL, '_blank')}
            >
              Contact Sales
            </button>
            <button
              className={clsx(s.button, s.buttonLight)}
              onClick={() => window.open(MARKETPLACE_KNOW_MORE_URL, '_blank')}
            >
              Know More
            </button>
          </div>
          <div className={s.cardWrapper}>
            <div className={s.cardContainer}>
              {[...verticals, ...verticals]
                .filter(
                  vertical =>
                    vertical.key && CONTENT_TYPES_KEYS.includes(vertical.key)
                )
                .map(vertical => {
                  return (
                    <div
                      key={vertical.key}
                      className={s.column}
                      aria-hidden="true"
                    >
                      <img
                        height={113}
                        width={192}
                        className={s.thumbnail}
                        src={vertical.thumbnails?.default}
                        alt="thumbnail"
                      />
                      <div className={s.verticalContentContainer}>
                        <span className={s.verticalTitle}>
                          {vertical.title}
                        </span>
                        <span className={s.description}>
                          {vertical.description}
                        </span>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentTypesBanner
